import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
      <span className="text-6xl font-bold text-slate-200">404</span>
      <h2 className="text-xl font-semibold text-slate-900">页面未找到</h2>
      <Link to="/" className="rounded-lg bg-blue-600 px-4 py-2 text-[13px] font-semibold text-white">
        返回首页
      </Link>
    </div>
  );
}
